import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import Button from '../../../../../Button'
import { useSearchParams } from 'react-router-dom'
import { Box, Grid } from '@mui/material'
import moment from 'moment-timezone'
import Loader from '../../../../../Loader'
import { getPaymentMethodString } from '../BillingSettings/BillingTerms'
import BillingPeriodHeader from '../Shared/BillingPeriodHeader'
import InvoiceDataTable from '../Shared/InvoiceDataTable'
import JumboStat from '../Shared/JumboStat'

function InvoiceDetails({ invoiceDetails, billingTerms, paymentProfileType, isError }) {
    const [, setSearchParams] = useSearchParams()
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
    return (
        invoiceDetails ? <>
            <Button startIcon={<ArrowBackIcon />} variant={'outlined'} color="primary" label={'View All Invoices'} onClick={() => setSearchParams('')}></Button>
            <BillingPeriodHeader firstDay={invoiceDetails.billingCycleStart} lastDay={invoiceDetails.billingCycleEnd} />
            <Grid container sx={{ marginBottom: '10px' }} columns={16} spacing={1}>
                <Grid item xs={'auto'}>
                    <Box sx={{ borderRight: '1px solid #C5C5C5', padding: '0px 15px 8px 0px', paddingTop: '0', paddingBottom: '0' }}>
                        Invoice #{invoiceDetails.invoiceId}
                    </Box>
                </Grid>
                <Grid item xs={'auto'}>
                    <Box sx={{ borderRight: '1px solid #C5C5C5', padding: '0px 15px 8px 0px', paddingTop: '0', paddingBottom: '0' }}>
                        Subscription ID #{invoiceDetails.subscriptionId}
                    </Box>
                </Grid>
                <Grid item xs={'auto'}>
                    <Box sx={{ padding: '0px 15px 8px 0px', paddingTop: '0', paddingBottom: '0' }}>
                        Payment Method: {(paymentProfileType && paymentProfileType.toLowerCase() !== billingTerms?.paymentInfo?.type?.toLowerCase()) ? paymentProfileType : getPaymentMethodString(billingTerms?.paymentInfo)}
                    </Box>
                </Grid>
            </Grid>
            <Grid container sx={{ marginBottom: '50px' }} columns={16} spacing={1}>
                <Grid item xs={'auto'}>
                    <Box sx={{ borderRight: '1px solid #C5C5C5', padding: '0px 15px 8px 0px', paddingTop: '0', paddingBottom: '0' }}>
                        Issue Date: {moment(invoiceDetails.issuedDate).format('M/DD/YYYY')}
                    </Box>
                </Grid>
                <Grid item xs={'auto'}>
                    <Box sx={{ padding: '0px 15px 8px 0px', paddingTop: '0', paddingBottom: '0' }}>
                        Due Date: {moment(invoiceDetails.dueDate).format('M/DD/YYYY')}
                    </Box>
                </Grid>
            </Grid>
            <Grid container sx={{ marginBottom: '50px', textAlign: 'center' }} columnSpacing={10} rowSpacing={0}>
                <JumboStat name={'Total Orders'} value={invoiceDetails.totalOrders} />
                <JumboStat name={'Total Sales'} value={formatter.format(invoiceDetails.totalSales)} />
                <JumboStat name={'Total Commission'} value={formatter.format(invoiceDetails.totalCommission)} />
                <JumboStat name={'Status'} value={invoiceDetails.status} />
            </Grid>
            <InvoiceDataTable invoiceItems={invoiceDetails.items} />


        </> : isError ?
            <>
                <Button startIcon={<ArrowBackIcon />} variant={'outlined'} color="primary" label={'View All Invoices'} onClick={() => setSearchParams('')}></Button>
                <InvoiceDataTable invoiceItems={[]} />
            </>
            : <Loader />

    )
}

export default InvoiceDetails